import { render } from "./CIPage.vue?vue&type=template&id=cc765a7a"
import script from "./CIPage.vue?vue&type=script&lang=js"
export * from "./CIPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__